import { get } from 'helpers/apiHelpers';
import isEmpty from 'lodash/isEmpty';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/CustomButtons/Button.jsx';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { useEffect } from 'react';

const CustomRemoveBody = ({
  classes,
  elementId,
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  removeItem = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  closeModal = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function -- FIXME
  handleAfterRemove = () => {},
}) => {
  const { t } = useTranslation();
  const [ingredientOccurrence, setIngredientOccurrence] = useState({
    dishes: [],
    recipes: [],
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  useEffect(async () => {
    const ingredientId = elementId.split('/').pop();
    const newIngredientOccurrence = await get(
      `ingredient-usage/${ingredientId}`
    );

    setIngredientOccurrence({
      dishes: newIngredientOccurrence?.dishes ?? [],
      recipes: newIngredientOccurrence?.recipes ?? [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const handleRemove = async () => {
    try {
      await removeItem(elementId);
      handleAfterRemove();
      closeModal();
    } catch (error) {
      // eslint-disable-next-line no-console -- FIXME
      console.log('Error: ', error);
    }
  };

  return (
    <div>
      {!isEmpty(ingredientOccurrence?.dishes) && (
        <p>
          <span style={{ fontWeight: 'bold' }}>
            {t(
              '$*list.ingredientsList.customRemoveBody.occurresInDishes',
              '$$Występuje w daniach:'
            )}
          </span>{' '}
          {ingredientOccurrence?.dishes.map(({ name }) => name).join(', ')}
        </p>
      )}
      {!isEmpty(ingredientOccurrence?.recipes) && (
        <p>
          <span style={{ fontWeight: 'bold' }}>
            {t(
              '$*list.ingredientsList.customRemoveBody.occurresInRecipes',
              '$$Występuje w przepisach:'
            )}
          </span>{' '}
          {ingredientOccurrence?.recipes.map(({ name }) => name).join(', ')}
        </p>
      )}
      <div
        style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}
      >
        <Button
          color="danger"
          style={{ margin: '5px' }}
          className={classes.marginRight}
          onClick={closeModal}
        >
          {t('common.no', '$$NIE')}
        </Button>
        <Button
          color="success"
          className={classes.marginLeft}
          onClick={handleRemove}
        >
          {t('common.yes', '$$TAK')}
        </Button>
      </div>
    </div>
  );
};

export default CustomRemoveBody;
